import { BaseReducer } from '@identic/api';
import { DataSourceState, DataSourceInitialState, DataSourceActions } from './data-source.state';

export function DataSourceReducer(state: DataSourceState = DataSourceInitialState, action: any): DataSourceState {
  return BaseReducer(state, action, DataSourceActions);
}
// console.log(`%cDataSourceReducer::ngOnInit`, 'background:yellow');
